import type { AdminKpisPieSectionProps } from "../../models/admin-kpis.models";
import AdminKpisMetricTile from "./AdminKpisMetricTile";
import AdminKpisPieChart from "./AdminKpisPieChart";
import AdminKpisPieLegendRow from "./AdminKpisPieLegendRow";
import AdminKpisPieSectionTableActions from "./AdminKpisPieSectionTableActions";
import { memo } from "react";

const AdminKpisPieSection = ({
  title,
  section,
  dataTest,
  showSegmentPercentLabels = false,
  activeSegmentCode = null,
  onSegmentClick,
  onShowAll,
  onHideTable,
}: AdminKpisPieSectionProps) => {
  return (
    <section
      data-test={dataTest}
      className="flex min-w-0 flex-col justify-between border border-[#D7E2DE] bg-white p-5 shadow-sm dark:border-gray-700 dark:bg-gray-800"
    >
      <div className="mb-4 flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-xl font-semibold">{title}</h2>
        <span className="text-sm font-medium text-[#4A5655] dark:text-gray-300">{section.total} vessels</span>
      </div>
      <div className="grid min-w-0 gap-5 xl:grid-cols-[180px_minmax(0,1fr)]">
        <AdminKpisPieChart
          segments={section.segments}
          total={section.total}
          showSegmentPercentLabels={showSegmentPercentLabels}
        />
        <div className="min-w-0">
          <div className="flex h-full flex-col justify-between">
            <div className="grid">
              {section.segments.map((segment) => (
                <AdminKpisPieLegendRow
                  key={segment.code}
                  segment={segment}
                  isActive={activeSegmentCode === segment.code}
                  onClick={onSegmentClick}
                />
              ))}
            </div>

            <div className="ml-1 flex w-full items-center justify-between gap-3 text-xs font-bold text-[#4A5655] dark:text-gray-300">
              <span>TARGET: max 10%</span>
              <AdminKpisPieSectionTableActions onShowAll={onShowAll} onHideTable={onHideTable} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {section.kpis.map((metric) => (
          <AdminKpisMetricTile key={metric.label} metric={metric} />
        ))}
      </div>
    </section>
  );
};

export default memo(AdminKpisPieSection);
